import React, { useEffect, useState } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Checkbox from "@mui/material/Checkbox";
import ScopeModule from "./scope";
import CostModule from "./cost";
import ScheduleModule from "./schedule";
import AddDeliverableModule from "./addDeliverable";
import EditDeliverableModule from "./editDeliverable";
import AddMilestoneModule from "./addMilestone";
import EditMilestoneModule from "./editMilestone";
import AddResources from "./addResources";
import RemoveResources from "./removeresources";
import StrategicAlignment from "./strategicAlignment";
import { changeRequestItemValidate } from "../../../api/casp/changeRequestItem";
import { toast } from "react-toastify";
import { ChangeRequestModule } from "../../../constants/Module";
import { Action } from "../../../constants/Common";
import { Tooltip } from "@mui/material";
import { withTranslation } from "react-i18next";

const ChangeRequestAccordion = (props) => {
  const [expandedModule, setExpandedModule] = useState({});
  const [requestPayload, setRequestPayload] = useState([]);
  const [addTeamMembers, setAddTeamMembers] = useState([]);
  const [removedTeamMembers, setRemovedTeamMembers] = useState([]);

  useEffect(() => {
    const data = props.changeRequestDetails?.changeRequestItems.map(
      ({ displayPayload, sections, ...rest }) => {
        switch (rest.module) {
          case ChangeRequestModule.MILESTONE:
          case ChangeRequestModule.DELIVERABLE: {
            return { ...rest, payload: [...displayPayload] };
          }
          case ChangeRequestModule.PROJECT_USER: {
            if (rest.event === Action.CREATE) {
              setAddTeamMembers(displayPayload.users);
            } else if (rest.event === Action.DELETE) {
              setRemovedTeamMembers(displayPayload.users);
            }
            return { ...rest };
          }
          default:
            return { ...rest };
        }
      }
    );
    setRequestPayload(data);
  }, []);

  const removeItemFromPayload = (item, itemIndex) => {
    switch (item.module) {
      case ChangeRequestModule.MILESTONE:
      case ChangeRequestModule.DELIVERABLE: {
        const objWithIdIndex = requestPayload.findIndex(
          (obj) => obj.module === item.module && obj.event === item.event
        );
        if (objWithIdIndex !== -1) {
          if (requestPayload.length === 1 && requestPayload[objWithIdIndex].payload?.length === 1) {
            return toast.error(
              "You need to introduce at least one module change!"
            );
          }
          setRequestPayload((prevState) => {
            prevState[objWithIdIndex] = {
              ...prevState[objWithIdIndex],
              payload: [...prevState[objWithIdIndex].payload].filter(
                (_, eachIndex) => eachIndex !== itemIndex
              ),
            };
            if (prevState[objWithIdIndex].payload?.length === 0) {
              prevState.splice(objWithIdIndex, 1);
            }
            // props.emit([...prevState]);
            return [...prevState];
          });
          props?.setItemPayload((prevItemPayload) => {
            const itemPayloadFoundIndex = prevItemPayload.findIndex(
              (obj) => obj.module === item.module && obj.event === item.event
            );
            if (itemPayloadFoundIndex !== -1) {
              prevItemPayload[itemPayloadFoundIndex] = {
                ...prevItemPayload[itemPayloadFoundIndex],
                payload: [
                  ...prevItemPayload[itemPayloadFoundIndex].payload,
                ].filter((_, eachIndex) => eachIndex !== itemIndex),
              };
              if (
                prevItemPayload[itemPayloadFoundIndex].payload?.length === 0
              ) {
                prevItemPayload.splice(itemPayloadFoundIndex, 1);
              }
            }
            return [...prevItemPayload];
          });
        }
        break;
      }
      case ChangeRequestModule.PROJECT_USER: {
        const objWithIdIndex = requestPayload.findIndex(
          (obj) => obj.module === item.module && obj.event === item.event
        );
        if (requestPayload.length === 1 && requestPayload[objWithIdIndex]?.payload?.users
          ?.length === 1) {
          return toast.error(
            "You need to introduce at least one module change!"
          );
        }

        if (item.event === Action.CREATE) {
          const objMemberIdIndex = addTeamMembers.findIndex(
            (obj) => obj.id === item.item.id
          );

          if (objMemberIdIndex !== -1) {
            addTeamMembers.splice(objMemberIdIndex, 1);
          }
        }

        if (item.event === Action.DELETE) {
          const objMemberIdIndex = removedTeamMembers.findIndex(
            (obj) => obj.id === item.item.id
          );

          if (objMemberIdIndex !== -1) {
            removedTeamMembers.splice(objMemberIdIndex, 1);
          }
        }

        if (objWithIdIndex !== -1) {
          setRequestPayload((prevState) => {
            prevState[objWithIdIndex] = {
              ...prevState[objWithIdIndex],
              payload: {
                users: [...prevState[objWithIdIndex].payload.users].filter(
                  (_, eachIndex) => eachIndex !== itemIndex
                ),
              },
            };
            // props.emit([...prevState]);
            if (prevState[objWithIdIndex]?.payload?.users?.length === 0) {
              prevState.splice(objWithIdIndex, 1);
            }
            return [...prevState];
          });

          props?.setItemPayload((prevItemPayload) => {
            const itemPayloadFoundIndex = prevItemPayload.findIndex(
              (obj) => obj.module === item.module && obj.event === item.event
            );
            if (itemPayloadFoundIndex !== -1) {
              prevItemPayload[itemPayloadFoundIndex] = {
                ...prevItemPayload[itemPayloadFoundIndex],
                payload: {
                  users: [
                    ...prevItemPayload[itemPayloadFoundIndex].payload.users,
                  ].filter((_, eachIndex) => eachIndex !== itemIndex),
                },
              };
              if (
                prevItemPayload[itemPayloadFoundIndex]?.payload?.users
                  ?.length === 0
              ) {
                prevItemPayload.splice(itemPayloadFoundIndex, 1);
              }
            }
            return [...prevItemPayload];
          });
        }
        break;
      }
      default:
        break;
    }
    toast.success("Changes saved successfully");
  };

  const handleValidate = async (event, data, resolve, reject) => {
    try {
      let item;
      let payload = {
        projectId: props.changeRequestDetails.project.id,
      };
      switch (event.module) {
        case ChangeRequestModule.PROJECT: {
          let ids = []
          if(data?.schedule){
             requestPayload.find((rp) => rp.module === ChangeRequestModule.DELIVERABLE && rp.event === Action.UPDATE)?.payload.forEach((item) =>{
              if(item.startDate?.new || item.endDate?.new){
                ids.push(item.id)
              }
            })
          }
          let totalDeliverableCost = 0
          if(data?.projectCost){
            const getAllConcernedDeliverables = requestPayload.filter((rp) => {
              return [ChangeRequestModule.DELIVERABLE].includes(rp.module) && [Action.CREATE, Action.UPDATE].includes(rp.event)
            })?.map((_rp) => {
              const event = _rp.event
              const newPayload = _rp.payload.map((_p) => ({
                event,
                ..._p
              }))
              return newPayload
            }).flat()
            getAllConcernedDeliverables.forEach((concernedDeliverable) => {
  
              if (concernedDeliverable.event === Action.CREATE) {
                totalDeliverableCost += concernedDeliverable.cost
              } else if (concernedDeliverable.event === Action.UPDATE && concernedDeliverable?.cost && concernedDeliverable?.cost?.old && concernedDeliverable?.cost?.new) {
                totalDeliverableCost = totalDeliverableCost - concernedDeliverable?.cost?.old + concernedDeliverable?.cost?.new
              }
            });
            if (event.event === Action.CREATE) {
              totalDeliverableCost += data.cost
            } else if (event.event === Action.UPDATE && data?.cost && data?.cost?.old && data?.cost?.new) {
              totalDeliverableCost = totalDeliverableCost - data.cost.old + data.cost.new
            }
          }

          item = {
            module: event.module,
            moduleId: props.changeRequestDetails.project.id.toString(),
            event: event.event,
            payload: { ...data },
          };
          payload.item = item;
          payload.updatedDeliverableIds = ids
          payload.deliverableCost = totalDeliverableCost

          break;
        }
        case ChangeRequestModule.PROJECT_USER: {
          const memberIds = data.map((item) => {
            return item.id;
          });

          item = {
            module: event.module,
            event: event.event,
            payload: {
              users: memberIds,
            },
          };
          payload.item = item;
          break;
        }
        case ChangeRequestModule.DELIVERABLE: {
          const getAllConcernedDeliverables = requestPayload
            .filter((rp) => {
              return (
                [ChangeRequestModule.DELIVERABLE].includes(rp.module) &&
                [Action.CREATE, Action.UPDATE].includes(rp.event)
              );
            })
            ?.map((_rp) => {
              const event = _rp.event;
              const newPayload = _rp.payload.map((_p) => ({
                event,
                ..._p,
              }));
              return newPayload.flat();
            })
            .flat();
          const totalDeliverablesChanges =
            getAllConcernedDeliverables.length + 1;
          let totalDeliverableWeight = 0;
          let totalDeliverableCost = 0
          getAllConcernedDeliverables.forEach((concernedDeliverable) => {
            if (concernedDeliverable.event === Action.CREATE) {
              totalDeliverableWeight += concernedDeliverable.weight;
              totalDeliverableCost += concernedDeliverable.cost
            } else if (
              concernedDeliverable.event === Action.UPDATE &&
              concernedDeliverable?.weight &&
              concernedDeliverable?.weight?.old >= 0 &&
              concernedDeliverable?.weight?.new >= 0
            ) {
              totalDeliverableWeight =
                totalDeliverableWeight -
                concernedDeliverable?.weight?.old +
                concernedDeliverable?.weight?.new;
            } else if (concernedDeliverable.event === Action.UPDATE && concernedDeliverable?.cost && concernedDeliverable?.cost?.old && concernedDeliverable?.cost?.new) {
              totalDeliverableCost = totalDeliverableCost - concernedDeliverable?.cost?.old + concernedDeliverable?.cost?.new
            }
          });
          if (event.event === Action.CREATE) {
            totalDeliverableWeight += data.weight;
            totalDeliverableCost += data.cost
          } else if (
            event.event === Action.UPDATE &&
            data?.weight &&
            data?.weight?.old >= 0 &&
            data?.weight?.new >= 0
          ) {
            totalDeliverableWeight =
              totalDeliverableWeight - data.weight.old + data.weight.new;
          } else if (event.event === Action.UPDATE && data?.cost && data?.cost?.old && data?.cost?.new) {
            totalDeliverableCost = totalDeliverableCost - data.cost.old + data.cost.new
          }

          let dataToSend = null;
          if (event.event === Action.CREATE) {
            dataToSend = { ...data };
          } else if (event.event === Action.UPDATE) {
            dataToSend = Object.fromEntries(
              Object.entries(data).filter(([dataKey, dataValue]) => {
                if (["id"].includes(dataKey)) {
                  return true;
                } else {
                  const tempData = dataKey === 'weight' ? (typeof dataValue === 'object' && !Array.isArray(dataValue) && dataValue !== null && dataValue?.old >= 0 && dataValue?.new >= 0) : (typeof dataValue === 'object' && !Array.isArray(dataValue) && dataValue !== null && dataValue?.old && dataValue?.new)
                  return tempData
                }
              })
            );
          }
          item = {
            module: event.module,
            event: event.event,
            payload: dataToSend,
          };
          
          payload.item = item;
          payload.totalDeliverables = totalDeliverablesChanges;
          payload.deliverableWeight = totalDeliverableWeight;
          payload.deliverableCost = totalDeliverableCost
          payload.projectCost = requestPayload.find(
            (rp) =>
            rp.module === ChangeRequestModule.PROJECT &&
            rp.event === Action.UPDATE
            )?.payload?.projectCost?.new ?? props.changeRequestDetails?.project?.projectCost
            let ids = []
          if (event.event === Action.UPDATE) {
              requestPayload.find((rp) => rp.module === ChangeRequestModule.MILESTONE && rp.event === Action.UPDATE)?.payload.forEach((item) =>{
              if(item.estimatedStartDate?.new || item.estimatedEndDate?.new){
                ids.push(item.id)
              }
            }) 
          }
          payload.updatedMilestoneIds = ids
          break;
        }
        case ChangeRequestModule.MILESTONE: {
          const getAllMilestones = requestPayload
            .filter((rp) => {
              return (
                [ChangeRequestModule.MILESTONE].includes(rp.module) &&
                [Action.CREATE, Action.UPDATE].includes(rp.event)
              );
            })
            ?.map((_rp) => {
              const event = _rp.event;
              const newPayload = _rp.payload.map((_p) => ({
                event,
                ..._p,
              }));
              return newPayload.flat();
            })
            .flat();
          const getAllConcernedMilestones = getAllMilestones.filter(
            (_milestone) => _milestone.deliverableId === data.deliverableId
          );
          const totalMilestoneChanges = getAllMilestones.length + 1;
          let totalMilestoneWeight = 0;
          let totalMilestoneCost = 0
          getAllConcernedMilestones.forEach((concernedMilestone) => {
            if (concernedMilestone.event === Action.CREATE) {
              totalMilestoneWeight += concernedMilestone.weight;
              totalMilestoneCost += concernedMilestone.cost
            } else if (
              concernedMilestone.event === Action.UPDATE &&
              concernedMilestone?.weight &&
              concernedMilestone?.weight?.old >=0 &&
              concernedMilestone?.weight?.new >=0
            ) {
              totalMilestoneWeight =
                totalMilestoneWeight -
                concernedMilestone?.weight?.old +
                concernedMilestone?.weight?.new;
            } else if (concernedMilestone.event === Action.UPDATE && concernedMilestone?.cost && concernedMilestone?.cost?.old && concernedMilestone?.cost?.new) {
              totalMilestoneCost = totalMilestoneCost - concernedMilestone?.cost?.old + concernedMilestone?.cost?.new
            }
          });
          if (event.event === Action.CREATE) {
            totalMilestoneWeight += data.weight;
            totalMilestoneCost += data.cost
          } else if (
            event.event === Action.UPDATE &&
            data?.weight &&
            data?.weight?.old >=0 &&
            data?.weight?.new >=0
          ) {
            totalMilestoneWeight =
              totalMilestoneWeight - data.weight.old + data.weight.new;
          } else if (event.event === Action.UPDATE && data?.cost && data?.cost?.old && data?.cost?.new) {
            totalMilestoneCost = totalMilestoneCost - data.cost.old + data.cost.new
          }

          let dataToSend = null;
          if (event.event === Action.CREATE) {
            dataToSend = { ...data };
            delete dataToSend.deliverableObject;
            delete dataToSend.deliverableCost
          } else if (event.event === Action.UPDATE) {
            dataToSend = Object.fromEntries(
              Object.entries(data).filter(([dataKey, dataValue]) => {
                if (["id", "deliverableId"].includes(dataKey)) {
                  return true;
                } else {
                  const tempData = dataKey === 'weight' ? (typeof dataValue === 'object' && !Array.isArray(dataValue) && dataValue !== null && dataValue?.old >= 0 && dataValue?.new >= 0) : (typeof dataValue === 'object' && !Array.isArray(dataValue) && dataValue !== null && dataValue?.old && dataValue?.new)
                  return tempData
                }
              })
            );
          } 

          let ids = []
          if (event.event === Action.UPDATE) {
              requestPayload.find((rp) => rp.module === ChangeRequestModule.MILESTONE && rp.event === Action.UPDATE)?.payload.forEach((item) =>{
              if(item.cost?.new){
                ids.push(item.id)
              }
            }) 
          }
          item = {
            module: event.module,
            event: event.event,
            payload: dataToSend,
          };
          payload.item = item;
          payload.totalMilestones = totalMilestoneChanges;
          payload.milestoneWeight = totalMilestoneWeight;
          payload.milestoneCost = totalMilestoneCost
          payload.deliverableCost = data.deliverableCost
          payload.updatedMilestoneIds = ids
          
          break;
        }
        default:
          break;
      }
      let res = {
        statusCode: 200,
      };
      if (data) {
        res = await changeRequestItemValidate(payload);
      }
      if (res.statusCode === 200) {
        switch (event.module) {
          case ChangeRequestModule.PROJECT: {
            const objWithIdIndex = requestPayload.findIndex(
              (obj) => obj.module === event.module && obj.event === event.event
            );
            if (objWithIdIndex !== -1) {
              if (requestPayload.length === 1 && !data && Object.keys(requestPayload[objWithIdIndex].payload).length === 1) {
                reject();
                return toast.error(
                  "You need to introduce at least one module change!"
                );
              }
              setRequestPayload((prevState) => {
                if (!data) {
                  delete prevState[objWithIdIndex].payload[event.key];
                  if (
                    Object.keys(prevState[objWithIdIndex].payload).length === 0
                  ) {
                    prevState.splice(objWithIdIndex, 1);
                  }
                } else {
                  prevState[objWithIdIndex].payload = {
                    ...prevState[objWithIdIndex].payload,
                    ...data,
                  };
                }
                return [...prevState];
              });
              props?.setItemPayload((prevState) => {
                if (prevState.length) {
                  const indexFound = prevState.findIndex(
                    (obj) =>
                      obj.module === event.module && obj.event === event.event
                  );
                  if (indexFound !== -1) {
                    if (!data) {
                      delete prevState[indexFound].payload[event.key];
                      if (
                        Object.keys(prevState[indexFound].payload).length === 0
                      ) {
                        prevState.splice(indexFound, 1);
                      }
                    } else {
                      prevState[indexFound].payload = {
                        ...prevState[indexFound].payload,
                        ...data,
                      };
                    }
                  }
                }
                return [...prevState];
              });
            } else {
              setRequestPayload((prevState) => {
                props.setItemPayload((prevItemPayload) => [
                  ...prevItemPayload,
                  item,
                ]);
                return [...prevState, item];
              });
            }
            break;
          }
          case ChangeRequestModule.DELIVERABLE:
          case ChangeRequestModule.MILESTONE: {
            const objWithIdIndex = requestPayload.findIndex(
              (obj) => obj.module === event.module && obj.event === event.event
            );
            if (objWithIdIndex !== -1) {
              setRequestPayload((prevState) => {
                const newTempData = { ...data };
                delete newTempData.deliverableObject;
                if (event.event === Action.CREATE) {
                  props?.setItemPayload((prevItemPayload) => {
                    const FEP = [...prevItemPayload];
                    FEP[objWithIdIndex] = {
                      ...FEP[objWithIdIndex],
                      payload: [...FEP[objWithIdIndex].payload, newTempData],
                    };
                    return [...FEP];
                  });
                  // props.emit([...prevState]);
                  prevState[objWithIdIndex] = {
                    ...prevState[objWithIdIndex],
                    payload: [...prevState[objWithIdIndex].payload, data],
                  };
                } else if (event.event === Action.UPDATE) {
                  const tempData = { ...data };
                  const tempEntries = Object.entries(tempData);
                  const newTemp = Object.fromEntries(
                    tempEntries.filter(([_TKey, _TValue]) => {
                      if (["id", "deliverableId"].includes(_TKey)) {
                        return true;
                      } else {
                        const tempData = _TKey === 'weight' ? (typeof _TValue === 'object' && !Array.isArray(_TValue) && _TValue !== null && _TValue?.old >= 0 && _TValue?.new >= 0) : (typeof _TValue === 'object' && !Array.isArray(_TValue) && _TValue !== null && _TValue?.old && _TValue?.new)

                        return tempData;
                      }
                    })
                  );
                  props?.setItemPayload((prevItemPayload) => {
                    const FEP = [...prevItemPayload];
                    FEP[objWithIdIndex] = {
                      ...FEP[objWithIdIndex],
                      payload: [...FEP[objWithIdIndex].payload, newTemp],
                    };
                    return [...FEP];
                  });

                  // props.emit(...finalEmitPayload);

                  prevState[objWithIdIndex] = {
                    ...prevState[objWithIdIndex],
                    payload: [...prevState[objWithIdIndex].payload, data],
                  };
                }
                return [...prevState];
              });
            } else {
              setRequestPayload((prevState) => {
                const newTempData = { ...data };
                delete newTempData.deliverableObject;
                const deliverableItem = {
                  module: event.module,
                  event: event.event,
                  payload: [newTempData],
                };
                if (event.event === Action.CREATE) {
                  props?.setItemPayload((prevItemPayload) => {
                    return [...prevItemPayload, deliverableItem];
                  });
                  // props.emit(finalEmitPayload)
                } else if (event.event === Action.UPDATE) {
                  const tempPayload = [...deliverableItem.payload];
                  const newPayload = tempPayload.map((_TPayload) => {
                    const temp = { ..._TPayload };
                    const tempEntries = Object.entries(temp);
                    const newTemp = Object.fromEntries(
                      tempEntries.filter(([_TKey, _TValue]) => {
                        if (["id", "deliverableId"].includes(_TKey)) {
                          return true;
                        } else {
                          const tempData = _TKey === 'weight' ? (typeof _TValue === 'object' && !Array.isArray(_TValue) && _TValue !== null && _TValue?.old >= 0 && _TValue?.new >= 0) : (typeof _TValue === 'object' && !Array.isArray(_TValue) && _TValue !== null && _TValue?.old && _TValue?.new)

                          return tempData;
                        }
                      })
                    );
                    return newTemp;
                  });
                  deliverableItem.payload = [...newPayload];
                  props?.setItemPayload((prevItemPayload) => {
                    return [...prevItemPayload, deliverableItem];
                  });
                }
                return [
                  ...prevState,
                  {
                    module: event.module,
                    event: event.event,
                    payload: [data],
                  },
                ];
              });
            }
            break;
          }
          case ChangeRequestModule.PROJECT_USER: {
            const objWithIdIndex = requestPayload.findIndex(
              (obj) => obj.module === event.module && obj.event === event.event
            );

            if (objWithIdIndex !== -1) {
              setRequestPayload((prevState) => {
                prevState[objWithIdIndex] = {
                  ...prevState[objWithIdIndex],
                  payload: {users: payload.item.payload.users}
                };

                return [...prevState];
              })
            }else{
              setRequestPayload((prevState) => {
                return [...prevState, item];
              });
            }

            if (event.event === Action.CREATE) {
              setAddTeamMembers(data);
            }

            if (event.event === Action.DELETE) {
              setRemovedTeamMembers(data);
            }
            
            props?.setItemPayload((prevItemPayload) => {
              const newPrevItemPayloadIndex = prevItemPayload.findIndex(
                (obj) =>
                  obj.module === event.module && obj.event === event.event
              );

              if (newPrevItemPayloadIndex !== -1) {
                prevItemPayload[objWithIdIndex] = {
                  ...prevItemPayload[objWithIdIndex],
                  payload: {users: payload.item.payload.users}
                };
                return [...prevItemPayload];
              }else{
                return [...prevItemPayload, item];

              }
            });
            break;
          }
          default:
            break;
        }
        if (resolve) {
          resolve();
        }

        toast.success("Changes saved successfully");
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error(err.message);
      console.log("161=>", err);
      if (reject) {
        reject();
      }
    }
  };

  const changeRequestModules = [
    {
      id: props.t("1"),
      moduleName: props.t("Scope"),
      moduleDescription: (
        <ScopeModule
          project={props.changeRequestDetails.project}
          updatedProject={
            requestPayload.find(
              (rp) =>
                rp.module === ChangeRequestModule.PROJECT &&
                rp.event === Action.UPDATE
            ) ?? null
          }
          validate={handleValidate}
        />
      ),
      disabled: false,
    },
    {
      id: props.t("2"),
      moduleName: props.t("Cost"),
      moduleDescription: (
        <CostModule
          project={props.changeRequestDetails.project}
          updatedProject={
            requestPayload.find(
              (rp) =>
                rp.module === ChangeRequestModule.PROJECT &&
                rp.event === Action.UPDATE
            ) ?? null
          }
          validate={handleValidate}
        />
      ),
      disabled: false,
    },
    {
      id: props.t("3"),
      moduleName: props.t("Schedule"),
      moduleDescription: (
        <ScheduleModule
          project={props.changeRequestDetails.project}
          updatedProject={
            requestPayload.find(
              (rp) =>
                rp.module === ChangeRequestModule.PROJECT &&
                rp.event === Action.UPDATE && 
                (rp?.payload?.schedule || rp?.payload?.projectCost)
            )?.payload ?? null
          }
          deliverableCreatedList={requestPayload.find((rp) => rp.module === ChangeRequestModule.DELIVERABLE && rp.event === Action.CREATE)?.payload ?? []}
          deliverableUpdatedList={requestPayload.find((rp) => rp.module === ChangeRequestModule.DELIVERABLE && rp.event === Action.UPDATE)?.payload.filter((item) => item.startDate?.new || item.endDate?.new) ?? []}
          validate={handleValidate}
        />
      ),
      disabled: false,
    },
    {
      id: props.t("4"),
      moduleName: props.t("Add Milestones"),
      moduleDescription: (
        <AddMilestoneModule
          project={props.changeRequestDetails.project}
          validate={handleValidate}
          removeItemFromPayload={removeItemFromPayload}
          milestoneList={
            requestPayload.find(
              (rp) =>
                rp.module === ChangeRequestModule.MILESTONE &&
                rp.event === Action.CREATE
            )?.payload ?? []
          }
          updatedDeliverable={
            requestPayload.find(
              (rp) =>
                rp.module === ChangeRequestModule.DELIVERABLE &&
                rp.event === Action.UPDATE
            )?.payload.filter((item) => item.startDate?.new || item.endDate?.new || item?.cost?.new) ?? []
          }
        />
      ),
      disabled:
        !props.changeRequestDetails.project?._count.deliverables ?? true,
      message: props.t("You do not have any ongoing deliverables"),
    },
    {
      id: props.t("5"),
      moduleName: props.t("Edit Milestones"),
      moduleDescription: (
        <EditMilestoneModule
          project={props.changeRequestDetails.project}
          validate={handleValidate}
          removeItemFromPayload={removeItemFromPayload}
          milestoneList={
            requestPayload.find(
              (rp) =>
                rp.module === ChangeRequestModule.MILESTONE &&
                rp.event === Action.UPDATE
            )?.payload ?? []
          }
          updatedDeliverable={
            requestPayload.find(
              (rp) =>
                rp.module === ChangeRequestModule.DELIVERABLE &&
                rp.event === Action.UPDATE
            )?.payload.filter((item) => item.startDate?.new || item.endDate?.new || item?.cost?.new) ?? []
          }
        />
      ),
      disabled: !props.changeRequestDetails.project?._count.milestones ?? true,
      message: props.t("You do not have any ongoing milestones"),
    },
    {
      id: props.t("6"),
      moduleName: props.t("Add Deliverables"),
      moduleDescription: (
        <AddDeliverableModule
          project={props.changeRequestDetails.project}
          validate={handleValidate}
          removeItemFromPayload={removeItemFromPayload}
          deliverableList={
            requestPayload.find(
              (rp) =>
                rp.module === ChangeRequestModule.DELIVERABLE &&
                rp.event === Action.CREATE
            )?.payload ?? []
          }
          updatedProject={
            requestPayload.find(
              (rp) =>
                rp.module === ChangeRequestModule.PROJECT &&
                rp.event === Action.UPDATE && 
                (rp?.payload?.schedule || rp?.payload?.projectCost)
            )?.payload ?? null
          }
        />
      ),
      disabled: false,
    },
    {
      id: props.t("7"),
      moduleName: props.t("Edit Deliverables"),
      moduleDescription: (
        <EditDeliverableModule
          project={props.changeRequestDetails.project}
          validate={handleValidate}
          removeItemFromPayload={removeItemFromPayload}
          deliverableList={
            requestPayload.find(
              (rp) =>
                rp.module === ChangeRequestModule.DELIVERABLE &&
                rp.event === Action.UPDATE
            )?.payload ?? []
          }
          updatedProject={
            requestPayload.find(
              (rp) =>
                rp.module === ChangeRequestModule.PROJECT &&
                rp.event === Action.UPDATE && 
                (rp?.payload?.schedule || rp?.payload?.projectCost)
            )?.payload ?? null
          }
          milestoneCreatedList={requestPayload.find((rp) => rp.module === ChangeRequestModule.MILESTONE && rp.event === Action.CREATE)?.payload ?? []}
          milestoneUpdatedList={requestPayload.find((rp) => rp.module === ChangeRequestModule.MILESTONE && rp.event === Action.UPDATE)?.payload.filter((item) => item.estimatedStartDate?.new || item.estimatedEndDate?.new) ?? []}
        />
      ),
      disabled:
        !props.changeRequestDetails.project?._count.deliverables ?? true,
      message: props.t("You do not have any ongoing deliverables"),
    },
    {
      id: props.t("8"),
      moduleName: props.t("Add Resources"),
      moduleDescription: (
        <AddResources
          project={props.changeRequestDetails.project}
          teamMembers={addTeamMembers}
          teamMemberIds={
            requestPayload.find(
              (rp) =>
                rp.module === ChangeRequestModule.PROJECT_USER &&
                rp.event === Action.CREATE
            )?.payload?.users ?? []
          }
          removeItemFromPayload={removeItemFromPayload}
          validate={handleValidate}
        />
      ),
      disabled: false,
    },
    {
      id: props.t("9"),
      moduleName: props.t("Remove Resources"),
      moduleDescription: (
        <RemoveResources
          project={props.changeRequestDetails.project}
          teamMembers={removedTeamMembers}
          teamMemberIds={
            requestPayload.find(
              (rp) =>
                rp.module === ChangeRequestModule.PROJECT_USER &&
                rp.event === Action.DELETE
            )?.payload?.users ?? []
          }
          removeItemFromPayload={removeItemFromPayload}
          validate={handleValidate}
        />
      ),
      disabled: false,
    },
    // {
    //   id: "10",
    //   moduleName: "Strategic Alignment",
    //   moduleDescription: <StrategicAlignment />,
    // },
  ];
  return (
    <div>
      {requestPayload.length && changeRequestModules && (
        <div>
          {changeRequestModules.map((item, index) => (
            <Tooltip
              title={item.disabled ? item.message : ""}
              placement="right"
              key={item.id}
              className="cursor-pointer"
            >
              <Accordion
                expanded={expandedModule[item.id]}
                slotProps={{
                  transition: { unmountOnExit: true, mountOnEnter: true },
                }}
              >
                <AccordionSummary
                  disabled={item.disabled}
                  sx={{
                    pointerEvents: "none",
                    "& .MuiAccordionSummary-expandIconWrapper.Mui-expanded": {
                      transform: "rotate(0deg)",
                    },
                  }}
                  expandIcon={
                    item.disabled ? null : (
                      <Checkbox sx={{ pointerEvents: "auto" }} />
                    )
                  }
                >
                  <div className="d-flex justify-content-between w-100">
                    <div className="moduleDetail d-flex align-items-center">
                      <div className="moduleId">{item.id}.</div> &nbsp;
                      <span className=" cursor-pointer">
                        {" "}
                        {item.moduleName}
                      </span>
                    </div>
                  </div>
                </AccordionSummary>
                <AccordionDetails
                  className="p-3 bg-white"
                  disabled={item.disabled}
                >
                  <div className="moduleContent">
                    <div className="moduleDesc">{item.moduleDescription}</div>
                  </div>
                </AccordionDetails>
              </Accordion>
            </Tooltip>
          ))}
        </div>
      )}
    </div>
  );
}

export default withTranslation() (ChangeRequestAccordion)
